const impliedActions = Object.freeze({
  crud: new Set(["create", "read", "update", "delete", "view"]),
  read: new Set(["view"]),
  view: new Set(["read"]),
});

/**
 * Canonical action implications. These implications only apply within the
 * resource for which the action was granted.
 */
export function actionImplies(grantedAction, requiredAction) {
  if (grantedAction == null || requiredAction == null) return false;

  const granted = String(grantedAction).trim().toLowerCase();
  const required = String(requiredAction).trim().toLowerCase();
  if (!granted || !required) return false;

  // manage and the explicit wildcard cover domain-specific actions as well.
  if (granted === "manage" || granted === "*") return true;
  if (granted === required) return true;

  return impliedActions[granted]?.has(required) ?? false;
}
